import { AE_LOGO_URL, NAV_LINKS } from "@/lib/constants";

export default function Footer() {
    return (
        <footer
            data-testid="footer-section"
            className="relative bg-ae-ink text-white pt-20 pb-10 overflow-hidden"
        >
            <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[440px] w-[640px] rounded-full bg-ae-orange/20 blur-[140px]" />
            <div
                className="absolute inset-0 opacity-[0.05]"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
                    backgroundSize: "56px 56px",
                }}
            />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src={AE_LOGO_URL}
                                alt="AE Logo"
                                className="h-12 w-12 rounded-full object-cover"
                            />
                            <div>
                                <div className="font-display font-extrabold text-2xl tracking-tight">
                                    AE
                                </div>
                                <div className="text-xs uppercase tracking-[0.22em] text-white/50 font-semibold">
                                    Amplified eSolutions Inc.
                                </div>
                            </div>
                        </div>
                        <p className="mt-6 text-white/65 max-w-md leading-relaxed">
                            AI-powered advertising, software and digitally enhanced brand
                            experiences. Built to help bold brands amplify everything.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.22em] font-bold text-ae-orange">
                            Explore
                        </div>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.label}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                                        className="text-white/75 hover:text-ae-orange transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs uppercase tracking-[0.22em] font-bold text-ae-orange">
                            Contact
                        </div>
                        <ul className="mt-5 space-y-3 text-white/75">
                            <li data-testid="footer-office">
                                AE is work-from-anywhere. Online all the time. Email us if
                                you need our snail mail address.
                            </li>
                            <li>
                                <a
                                    href="mailto:info@amplifiedesolutions.com"
                                    className="hover:text-ae-orange transition-colors"
                                    data-testid="footer-email"
                                >
                                    info@amplifiedesolutions.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://amplifiedesolutions.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-ae-orange transition-colors"
                                    data-testid="footer-website"
                                >
                                    amplifiedesolutions.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="text-xs text-white/55">
                        © {new Date().getFullYear()} Amplified eSolutions Inc. All rights
                        reserved.
                    </div>
                    <div className="text-xs uppercase tracking-[0.22em] text-white/55 font-semibold">
                        Strategy · Creative · AI · Advertising · Software
                    </div>
                </div>
            </div>
        </footer>
    );
}
